/**
 * @file 在 Table 中移除截图字段&处理文件链接
 * @author yinfangyan
 */

export default {
    handleTableContent(state) {
        if (state.topicData.topicInfo.extBeanList.length) {
            let newArrayContent = state.topicData.topicInfo.extBeanList.filter(item => {
                if(item.name !== '截图') {
                    if(item.name === '上传 Crash 堆栈文件') {
                        item.value = item.value.replace(/[\[\]"////]/g,'');
                        return item;
                    }
                    return item;
                }
            });
            return newArrayContent;
        }
        return [];
    }
};
